module.exports = __webpack_public_path__ + "static/img/8.2f9f905.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/4/zh/8.png
// module id = JMBW
// module chunks = 0